import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TrialBanner } from './TrialBanner';
import { ImpersonationBanner } from './ImpersonationBanner';
import { TourProvider } from '@/help/TourProvider';
import { HelpLauncher } from '@/help/HelpLauncher';

export function AppLayout() {
  return (
    <TourProvider>
      <div className="flex h-screen bg-background">
        <Sidebar />
        <div className="flex-1 flex flex-col overflow-hidden">
          <ImpersonationBanner />
          <TrialBanner />
          <main className="flex-1 overflow-y-auto">
            <Outlet />
          </main>
        </div>
        {/* Ajuda contextual (botão flutuante) + tours guiados */}
        <HelpLauncher />
      </div>
    </TourProvider>
  );
}
